import React, { useState, useEffect, useContext } from "react";
import { Route, Routes, Navigate, useNavigate, useLocation } from "react-router-dom";
import { WarehouseContext } from "../storage/context/index";
import { useFetchTenantInformation } from "../hooks/useFetchTenantInformation";
import { CreatorModule, DeveloperModule } from "../modules";
import { isCreatorModuleSpecificTenant } from "../utils/util";
import { tenantInfoApi } from "../api";
import { Production } from "../constants/constants";
import { UPDATE_CREATOR_LINKAGE_MODULE_STATUS, UPDATE_PRODUCTION_KEY_STATUS } from "../storage/reducers/types";
import { IntermediateLoader } from "../components";

export default function AuthenticatedRoutes(props) {
  const navigate = useNavigate();
  const fetchTenantInformation = useFetchTenantInformation();
  const {
    warehouse: { tenantInfo, environmentChanged },
    dispatchWarehouse,
  } = useContext(WarehouseContext);
  const [showCreatorModule, setShowCreatorModule] = useState(null);

  useEffect(() => {
    if (environmentChanged === true) {
      fetchTenantInformation();
      // Creating Product list based on environment
      // getProductsList(environment.current);
    }
  }, [environmentChanged]);

  useEffect(() => {
    // To check whether the production keys are available or not and to check whether the tenant is creator module specific or not
    (async () => {
      let tenantResponse = await tenantInfoApi.getTenantInfo(Production);
      let getTenantProducts;
      try {
        getTenantProducts = await tenantInfoApi.checkProductsEnabledForTenant(Production);
      } catch (err) {
        console.warn(err);
      }
      if (tenantResponse.length !== 0 && !!tenantResponse[0]?.apps[0]?.enabled_on_dashboard) {
        const clientSecrets = tenantResponse[0]?.apps[0].credentials;
        const clientSecret = clientSecrets[0]?.client_secret;
        dispatchWarehouse({
          type: UPDATE_PRODUCTION_KEY_STATUS,
          payload: {
            prodTenantId: tenantResponse[0]?.id,
            prodClientId: tenantResponse[0].apps[0]?.id,
            prodClientSecret: clientSecret,
            prodTenantAppName: tenantResponse[0].apps[0]?.name,
            productionEnabledTenantProducts: getTenantProducts.tenant_app_products,
          },
        });
        if (isCreatorModuleSpecificTenant(tenantResponse[0]?.id)) {
          setShowCreatorModule(true);
          dispatchWarehouse({ type: UPDATE_CREATOR_LINKAGE_MODULE_STATUS, payload: true });
        } else setShowCreatorModule(false);
      } else {
        setShowCreatorModule(false);
      }
    })();
  }, []);

  // useEffect(() => {
  //   (async () => {
  //     setShowCreatorModule(true);
  //   })();
  // }, []);

  useEffect(() => {
    if (tenantInfo.length === 0) fetchTenantInformation();
    // const interval = setInterval(() => {
    //   fetchTenantInformation();
    // }, 5000);
    // Creating Product list based on environment
    // getProductsList(environment.current);
    navigate(props.userRequestedLocation);
    // return () => clearInterval(interval);
  }, []);

  if (showCreatorModule === null) {
    return (
      <div className="loader-container" style={{ height: "100vh" }}>
        <IntermediateLoader />
      </div>
    );
  }

  return (
    <>
      {/* {showCreatorModule ? ( */}
      <Routes path="">
        <Route path="creators/*" element={<CreatorModule />} />
        <Route path="developers/*" element={<DeveloperModule />} />
        <Route path="*" element={<Navigate to="developers/*" />} />
      </Routes>
      {/* ) : ( */}
      {/* <Routes path="">
          <Route path="developers/*" element={<DeveloperModule />} />
          <Route path="*" element={<Navigate to="developers/" />} />
        </Routes>
      )} */}
    </>
  );
}
